<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t("string.edit_project_type") }}
      </h3>
      <div class="pull-right box-tools">
        <ButtonBack />
      </div>
    </div>
    <div class="box-body">
      <Form />
    </div>
  </div>
</template>

<script>
import Form from './Form'
import ButtonBack from '@/components/ButtonBack'

export default {
  name: 'Edit',
  components: { ButtonBack, Form },
  metaInfo () {
    return {
      title: this.$t('string.edit_project_type'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped></style>
